import { TabbedPage } from '@/components/TabbedPage';
import AuditDashboard from './AuditDashboard';
import CheckNumber from './CheckNumber';
import OptOutsRegistry from './OptOutsRegistry';
import { Shield, Search, Ban } from 'lucide-react';

// Audit / Check number / Opt-outs are all "is it safe to send to this number"
// tools, so they sit behind one sidebar entry instead of three.
export default function WhatsappToolsManager() {
  return (
    <TabbedPage
      title="WhatsApp Tools"
      breadcrumb="WhatsApp"
      description="Deliverability safety: account health, number reachability, and the opt-out registry."
      tabs={[
        { id: 'audit', label: 'Safety audit', icon: <Shield size={14} />, render: () => <AuditDashboard embedded /> },
        { id: 'check-number', label: 'Check number', icon: <Search size={14} />, render: () => <CheckNumber embedded /> },
        { id: 'opt-outs', label: 'Opt-outs', icon: <Ban size={14} />, render: () => <OptOutsRegistry embedded /> },
      ]}
    />
  );
}
